<div class="icon-area">
  @if (icon === DialogIcon.InfoRed) {
    <mat-icon class="status-icon icon icon-color-danger" aria-hidden="true">error</mat-icon>
  }
  @if (icon === DialogIcon.AlertRed) {
    <mat-icon class="status-icon icon icon-color-danger" aria-hidden="true">error</mat-icon>
  }
  @if (icon === DialogIcon.InfoGreenTick) {
    <mat-icon class="status-icon icon icon-color-success" aria-hidden="true">check_circle</mat-icon>
  }

  @if (icon === DialogIcon.CheckRedAlert) {
    <div class="large-icon-with-inset" aria-hidden="true">
      <img src="/assets/image/graphic/phone-camera.svg" class="large-icon">
      <mat-icon class="inset-icon color-error">error</mat-icon>
    </div>
  }

  @if (icon === DialogIcon.IdCard) {
    <div class="large-icon-with-inset inset-in-corner" aria-hidden="true">
      <img src="/assets/image/graphic/id-card.svg"  class="large-icon">
      <mat-icon class="inset-icon color-success">check_circle</mat-icon>
    </div>
  }
</div>

@if (show(title)) {
  <h2>{{ title }}</h2>
}

<div class="content">
  @for (paragraph of content; track paragraph) {
    <p>{{ paragraph }}</p>
  }
</div>

<div class="button-group">
  @if (show(secondary)) {
    <button id="dialog-button-1" class="btn btn-secondary btn-wide" (click)="secondaryClick()">{{ secondary }}</button>
  }
  @if (show(primary)) {
    <button id="dialog-button-2" class="btn btn-primary btn-wide" (click)="primaryClick()">{{ primary }}</button>
  }
</div>
